import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ISendSmsCodeRequest } from '../models/models'

export class CreateSMSCodeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/createSMSCode',
      requesterInfo,
    })
  }

  public async createSMSCode(request: ISendSmsCodeRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
